// extracted by mini-css-extract-plugin
export var banner = "_f8-0";
export var closeButton = "_f8-2";
export var greenCheckmark = "_f8-3";
export var hereLink = "_f8-4";
export var titleIcon = "_f8-1";